import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InviteAccept() {
    const { token } = useParams();
    const navigate = useNavigate();
    const { user, session, loading: authLoading } = useAuth();
    const [status, setStatus] = useState('idle'); // idle | accepting | ok | error
    const [error, setError] = useState(null);

    useEffect(() => {
        if (authLoading) return;
        if (!user) {
            // Need to sign in first; preserve token in URL
            navigate(`/auth/signin?next=/auth/invite/${token}`, { replace: true });
            return;
        }
        const accept = async () => {
            setStatus('accepting'); setError(null);
            try {
                await axios.post(`${API}/invitations/accept/${token}`, {}, {
                    headers: { Authorization: `Bearer ${session.access_token}` },
                });
                setStatus('ok');
                setTimeout(() => navigate('/app/dashboard'), 1200);
            } catch (e) {
                setError(e.response?.data?.detail || e.message);
                setStatus('error');
            }
        };
        accept();
    }, [authLoading, user, session, token, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-6">
            <div className="card-soft p-10 max-w-md w-full text-center">
                <div className="eyebrow mb-3">Invitation</div>
                <h1 className="font-heading text-3xl mb-4">Bienvenue sur African Valley</h1>
                {status === 'accepting' && (
                    <div className="text-foreground/70 inline-flex items-center" data-testid="invite-accepting"><Loader2 className="animate-spin mr-2" size={14} /> Acceptation en cours…</div>
                )}
                {status === 'ok' && <p className="text-secondary" data-testid="invite-ok">Invitation acceptée. Redirection…</p>}
                {status === 'error' && (
                    <>
                        <p className="text-destructive mb-6" data-testid="invite-error">{error}</p>
                        <Button onClick={() => navigate('/app/dashboard')} className="bg-primary hover:bg-primary-hover">Aller au tableau de bord</Button>
                    </>
                )}
            </div>
        </div>
    );
}
